<div class="slate full-width full-height">
	<app-page-header [iconId]="524">Return Mail</app-page-header>

	<app-search
		#returnMailSearch
		[ngStyle]="{ display: showReturnMailSingleForm ? 'none' : 'block' }"
		[showCriteria]="true"
		[searchId]="19"
		[customizeKey]="'return-mail'"
		(rowDoubleClicked)="showReturnMailForm($event)"
	>
	</app-search>

	<div *ngIf="showReturnMailSingleForm">
		<div class="action-buttons">
			<button id="backToSearch" mat-button class="action-button" (click)="backToSearch()">
				<app-db-icon
					[iconId]="523"
					[fixedWidth]="true"
					style="font-size: 20pt; vertical-align: middle"
					class="mr-sm"
				></app-db-icon
				>Back to Search
			</button>
		</div>
		<mat-card appearance="outlined" class="card" *ngIf="letterDetails">
			<mat-card-content>
				<div class="sidebar-row">
					<div class="sidebar-detail">
						<div class="sidebar-label">Status</div>
						<div class="sidebar-value">{{ letterDetails.status }}</div>
					</div>
					<div class="sidebar-detail">
						<div class="sidebar-label">Mail Type</div>
						<div class="sidebar-value">{{ letterDetails.mailType }}</div>
					</div>
					<div class="sidebar-detail">
						<div class="sidebar-label">Mail Code</div>
						<div class="sidebar-value">{{ letterDetails.letterCode }}</div>
					</div>
					<div class="sidebar-detail">
						<div class="sidebar-label">Mail Item Sent</div>
						<div class="sidebar-value">
							<button
								id="view-mail-pdf-button"
								mat-button
								class="action-button"
								style="margin: 0px"
								(click)="viewMailFile()"
							>
								<app-db-icon
									[iconId]="519"
									[fixedWidth]="true"
									style="font-size: 20pt; vertical-align: middle"
									class="mr-sm"
								></app-db-icon
								>View Mail PDF
							</button>
						</div>
					</div>
					<div class="sidebar-detail">
						<div class="sidebar-label">Sent Date</div>
						<div class="sidebar-value">{{ letterDetails.sentDate | moment: 'MM/DD/yyyy' }}</div>
					</div>
				</div>
				<div class="sidebar-row">
					<div class="sidebar-detail">
						<div class="sidebar-label">Mailed To</div>
						<div class="sidebar-value">{{ letterDetails.addressedTo }}</div>
					</div>
					<div class="sidebar-detail">
						<div class="sidebar-label">Mailing Address</div>
						<div class="sidebar-value">
							<span *ngIf="letterDetails.addressLine1">{{ letterDetails.addressLine1 }}<br /></span>
							<span *ngIf="letterDetails.addressLine2">{{ letterDetails.addressLine2 }}<br /></span>
							<span *ngIf="letterDetails.city">{{ letterDetails.city }}, </span
							><span *ngIf="letterDetails.state">{{ letterDetails.state }} </span
							><span *ngIf="letterDetails.zip">{{ letterDetails.zip }}</span>
						</div>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" class="card">
			<form [formGroup]="returnMailSingleForm">
				<div class="returnInfo">
					<mat-form-field>
						<mat-label>Returned Date</mat-label>
						<input
							id="return-mail-single-return-date-input"
							matInput
							[matDatepicker]="returnedDatePicker"
							formControlName="returnedDate"
							[max]="maxReturnedDate"
						/>
						<mat-datepicker-toggle matSuffix [for]="returnedDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #returnedDatePicker></mat-datepicker>
					</mat-form-field>

					<mat-form-field>
						<mat-label>Postmarked Date</mat-label>
						<input
							id="return-mail-single-postmarked-date-input"
							matInput
							[matDatepicker]="postmarkedDatePicker"
							formControlName="postmarkedDate"
							[max]="maxPostmarkedDate"
						/>
						<mat-datepicker-toggle matSuffix [for]="postmarkedDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #postmarkedDatePicker></mat-datepicker>
					</mat-form-field>

					<mat-form-field>
						<mat-label>Reason</mat-label>
						<mat-select id="return-mail-single-reason-select" formControlName="returnMailReasonId">
							<mat-option
								id="return-mail-single-reason-{{ i }}"
								*ngFor="let reason of returnMailReasons; let i = index"
								[value]="reason.returnMailReasonId"
							>
								{{ reason.description }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div style="margin-bottom: 10px">
					<span style="font-size: medium; font-style: italic"
						>If a new address is present, please complete the following address fields to re-send this
						mailing with a one-time address update.</span
					>
				</div>

				<div class="address">
					<mat-form-field style="width: 630px">
						<mat-label>Addressed To</mat-label>
						<input
							id="return-mail-single-address-to"
							matInput
							formControlName="resendTo_Name"
							type="text"
						/>
					</mat-form-field>
					<mat-form-field style="width: 630px">
						<mat-label>Address Line 1</mat-label>
						<input
							id="return-mail-single-address-line-1"
							matInput
							formControlName="resendTo_AddressLine1"
							type="text"
						/>
					</mat-form-field>
					<mat-form-field style="width: 630px">
						<mat-label>Address Line 2</mat-label>
						<input
							id="return-mail-single-address-line-2"
							matInput
							formControlName="resendTo_AddressLine2"
							type="text"
						/>
					</mat-form-field>
					<div class="cityStateZip">
						<mat-form-field>
							<mat-label>City</mat-label>
							<input id="return-mail-single-city" matInput formControlName="resendTo_City" type="text" />
						</mat-form-field>
						<mat-form-field>
							<mat-label>State</mat-label>
							<mat-select id="return-mail-single-state-select" formControlName="resendTo_StateId">
								<mat-option
									id="return-mail-single-state-{{ i }}"
									*ngFor="let state of states; let i = index"
									[value]="state.stateId"
									>{{ state.description }}</mat-option
								>
							</mat-select>
						</mat-form-field>
						<mat-form-field>
							<mat-label>Zip</mat-label>
							<input id="return-mail-single-zip" matInput formControlName="resendTo_Zip" type="text" />
						</mat-form-field>
					</div>
				</div>
				<app-progress-button
					(click)="processReturnMail()"
					[buttonText]="'Save'"
					[disabled]="saving"
				></app-progress-button>
			</form>
		</mat-card>
	</div>
</div>
